import styled from 'styled-components';
import { HeaderStyled } from '../HeaderStyled';
import { rem } from 'polished';

export const HeaderStyledDS = styled(HeaderStyled)`
    .help {
        svg {
            height: ${rem('32px')};
            width: ${rem('32px')};
            margin-left: ${rem(5)};

            path {
                fill: white;
            }
        }

        .label {
            svg {
                height: ${rem('12px')};
                width: ${rem('12px')};
            }
        }
    }
`;
